import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { briefing_path } from '@routes';
import { ClickTarget, ContentType, click } from '@tracking';

import { Briefing } from '../../interfaces/homepage';
import TimeAgo from '../TimeAgo';

interface BriefingProps {
  briefing: Briefing;
}

const BriefingFeedItem = ({
  briefing: { dek, headline, createdAt, slug, id, authors = [] },
}: BriefingProps) => {
  const { trackEvent } = useEventTracking({
    contentId: id,
    contentType: ContentType.Briefing,
    creatorIds: authors.map((author) => author.id),
  });

  return (
    <div className="border-0 border-b border-solid border-grayscale-gray px-16 py-32 sm:px-0 sm:py-48">
      <a
        onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.FeedBriefing }))}
        href={briefing_path(slug)}
      >
        <h3 className="briefing-headline m-0 p-0 font-suisse-screen text-headline-xxs font-normal text-black transition-colors duration-200 hover:text-primary-magenta sm:mb-0">
          {headline}
        </h3>
        <div className="my-8 line-clamp-2 font-suisse-neue text-body-md text-black *:m-0 *:hidden first-of-type:*:block sm:my-0">
          {dek}
        </div>
      </a>
      <TimeAgo className="text-grayscale-gray" date={createdAt} />
    </div>
  );
};

export default BriefingFeedItem;
